/**
 * What a position's TP/SL "Gain %" and "Loss %" are measured against.
 *
 * This modal used to divide by MAINTENANCE margin while the positions table,
 * the position-details modal and the order form's ROE% all use the margin the
 * position posts (initial margin = notional ÷ leverage). Maintenance margin is
 * a fraction of that, so the same trigger price read as a far larger
 * percentage here than anywhere else in the app.
 *
 * `pickMarginBasis` is the documented ladder (`utils/positionRoi.ts`): the
 * API's `margin_used` first, then isolated margin, then notional ÷ leverage.
 * `undefined` means no basis is known — a percentage cannot be offered at all,
 * and must never fall back to 0 or to the entry price.
 */
import { IRoiInputs, pickMarginBasis } from "../../utils/positionRoi";

export const tpslRoiBasis = (position?: IRoiInputs | null): number | undefined => {
  if (!position) return undefined;
  const basis = pickMarginBasis(position);
  return Number.isFinite(basis) && basis > 0 ? basis : undefined;
};
